import { render, staticRenderFns } from "./PatientFamilyForm.vue?vue&type=template&id=143636cb"
import script from "./PatientFamilyForm.vue?vue&type=script&lang=js"
export * from "./PatientFamilyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports